import apiCalls from "../../../config/paymentConfig/apiCalls";
import Headers from "../../../config/paymentConfig/headers";
// import ampUtility from "../../../helpers/paymentHelpers/amplitude/ampUtility";
import { keyMapsAction } from "../../../helpers/paymentHelpers/storeKeys";

export default {
  namespaced: true,
  state: {
    evoucherCard: {
      evoucherNumber: "",
      evoucherOtp: "",
      evoucherOtpError: "",
      isEvoucherModalOpen: false,
      isErrorMsg: "",
      currentScreen: "EVOUCHER",
      isKeyDisable: false,
      evoucherCodeResponse: {},
      evoucherPinResponse: {},
      evoucherThankYouResponse: {},
    },
    isGiftCardOrEvoucher: "E_VOUCHER"
  },
  getters: {},
  mutations: {
    updateGiftOrEvoucherOtpError(state, payload){
      state.evoucherCard.evoucherOtpError = payload
    },
    updateEvoucherResponse(state, payload) {
      state.evoucherCard.evoucherCodeResponse = payload;
    },
    updateGiftOrEvoucher(state, payload) {
      state.isGiftCardOrEvoucher = payload || "";
    },
    updateEvoucherThankYouResponse(state, payload) {
      state.evoucherCard.evoucherThankYouResponse = payload || {};
    },
    updateEvoucherPinResponse(state, payload) {
      state.evoucherCard.evoucherPinResponse = payload;
    },
    updateEvoucherIsDisableKey(state, payload) {
      state.evoucherCard.isKeyDisable = payload;
    },
    updateEvoucherScreen(state, payload) {
      state.evoucherCard.currentScreen = payload;
    },
    updateEvoucherOtp(state, payload) {
      state.evoucherCard.evoucherOtp = payload || "";
    },
    updateEvoucheModalOpen(state, payload) {
      state.evoucherCard.isEvoucherModalOpen = payload;
      if(!payload) state.evoucherCard = {
        evoucherNumber: "",
        evoucherOtp: "",
        isEvoucherModalOpen: false,
        isErrorMsg: "",
        currentScreen: "EVOUCHER",
        isKeyDisable: false,
        evoucherCodeResponse: {},
        evoucherPinResponse: {},
      }
    },
    updateEvoucherNumber(state, payload) {
      state.evoucherCard.evoucherNumber = payload || "";
    },
    updateCurrentrScreen(state, payload) {
      state.currentScreen = payload;
    },
    updateEvoucherErrorMsg(state, payload) {
      state.evoucherCard.isErrorMsg = payload || "";
    },
  },
  actions: {
    giftCardValidationHandler({ commit, state, dispatch }, payload) {
      let obj = {
        instrumentDetails: {
          evoucherCode: state.evoucherCard.evoucherNumber,
          evoucherPin: payload == 'PIN_HAND' && state.evoucherCard.evoucherOtp || ""
        },
        secondaryPaymentId: "CASH",
      };
      if (state.evoucherCard.evoucherNumber)
        dispatch(keyMapsAction.INIT_PLACE_ORDER, obj, { root: true });
    },
    resendGiftCardOtpApi({ state, commit }, payload){
      apiCalls.GIFTCARD_OTP_API({
        headers: Headers(),
        payload: state.evoucherCard.evoucherNumber ? state.evoucherCard.evoucherNumber : payload,
      }).then(res => {
        commit("updateGiftOrEvoucherOtpError", res)
        if(res?.status == "FAILED") {
          // setTimeout(() => {
          //   ampUtility.impressionPayActionEventAmp({
          //     screenName: "confirm_pin_gcevoucher",
          //     previousScreenname: "/confirm_amount_gcevoucher",
          //     eventAction: "impression_gcvoucher_error",
          //     errormsg: "otp is wrong",
          //     paymentId: 'evoucher' || ""
          //   })
          // }, 1000);
        }
      }).catch(err => {
        console.log("otp call error");
      })
    }
  },
};
